import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';
import {
  ENVIRONMENT_CONFIG,
  EnvironmentConfiguration,
} from './environments/models/environment.model';
import { bootstrapApplication, platformBrowser } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { HEADER_CONFIG } from './app/app.module';

if (environment.production) {
  enableProdMode();
}

void fetch('./assets/environment-config.json')
  .then((resp) => resp.json())
  .then((config: EnvironmentConfiguration) => {
    bootstrapApplication(AppComponent, {
      ...appConfig,
      providers: [
        ...appConfig.providers,
        { provide: ENVIRONMENT_CONFIG, useValue: config },
        {
          provide: HEADER_CONFIG,
          useValue: {
            redirectUri: config.oAuth.redirectURL,
            postLogoutRedirectUri: config.oAuth.postLogoutRedirectURL,
            clientId: config.oAuth.clientId,
            authority: config.oAuth.authority,
            authorityDomain: config.oAuth.authorityDomain,
            portalURL: config.portal.redirectURL,
          },
        },
      ],
    }).catch((err) => {
      // eslint-disable-next-line no-console
      console.error(err);
    });
  });
